<template>

	<!-- FICHA -->
	<div class="content-ficha">
		
		<div
		click-outside="handleClickOutside"
		v-if="ready"
		:class="['page-element', 
		{'with-header-footer': (getViews.masterheaderleft || getViews.masterheaderright) && (getViews.masterfooterleft || getViews.masterfooterright)}, 
		{'with-header': getViews.masterheaderleft || getViews.masterheaderright}, 
		{'with-footer': getViews.masterfooterleft || getViews.masterfooterright},
		{'detail-page': detailPage},
		{'device-mobile': ['xs','sm'].includes($mq)}]">
			
			<!-- Control error de carga -->
			<template v-if="error && (error.estructura || error.personalizacion)">

				<el-alert
					title="Ha ocurrido un error, inténtalo de nuevo mas tarde"
					type="error"
					:closable="false"
					:center="true"
					style="
						position: absolute;
						left: 15px;
						top: 15px;
						right: 15px;
						width: auto;
					">
				</el-alert>

			</template>
			<template v-else>

				<!-- [MASTER-HEADER] -->
				<section class="section-master section-master--header">

					<!-- [MASTER-HEADER-LEFT] -->
					<section class="section-left">
						<Zona
						:class="[{'full-height': getViews.masterheaderleft.some(s => s.hook.zonafullheight)}]"
						ref="zona_master_header_left"
						v-if="getViews.masterheaderleft"
						:id="id"
						:ficha="ficha"
						:entidad="entidad"
						:views="getViews.masterheaderleft"
						@saved="saved"
						@afterActions="afterActions"
						@setActionId="setActionId"
						@setCurrentAction="setCurrentAction"
						@reloadDataTable="reloadDataTable"
						@openWindow="val => $emit('openWindow',val)"/>
					</section>

					<!-- [MASTER-HEADER-RIGHT] -->
					<section class="section-right">
						<Zona
						:class="[{'full-height': getViews.masterheaderright.some(s => s.hook.zonafullheight)}]"
						ref="zona_master_header_right"
						v-if="getViews.masterheaderright"
						:id="id"
						:ficha="ficha"
						:entidad="entidad"
						:views="getViews.masterheaderright"
						@saved="saved"
						@afterActions="afterActions"
						@setActionId="setActionId"
						@setCurrentAction="setCurrentAction"
						@reloadDataTable="reloadDataTable"
						@openWindow="val => $emit('openWindow',val)"/>
					</section>
				</section>

				<!-- [LEFT] -->
				<section 
					ref="section-left" 
					:class="[
						'section-left',
						{ 'collapsed': (!getViews.leftheader && !getViews.leftbody && !getViews.leftfooter) || !getFichaById(id).section.left.open },
						{ 'drawer-style': this.id == undefined ? false : true }
					]">

					<div class="section-left-content">

						<!-- Boton cerrar cuando el estilo drawer esta activo -->
						<div class="drawer-style-button" @click="setFichaVisibleSection({id, section: 'left'})">
							<i class="el-icon-s-fold"></i>
						</div>

						<!-- [LEFT-HEADER] -->
						<Zona
						ref="zona_left_header"
						:class="[{'full-height': getViews.leftheader.some(s => s.hook.zonafullheight)}]"
						v-if="getViews.leftheader"
						:id="id"
						:ficha="ficha"
						:entidad="entidad"
						:views="getViews.leftheader"
						@saved="saved"
						@afterActions="afterActions"
						@setActionId="setActionId"
						@setCurrentAction="setCurrentAction"
						@reloadDataTable="reloadDataTable"
						@openWindow="val => $emit('openWindow',val)"/>

						<!-- [LEFT-BODY] -->
						<Zona
						ref="zona_left_body"
						:class="[{'full-height': getViews.leftbody.some(s => s.hook.zonafullheight)}]"
						v-if="getViews.leftbody"
						:id="id"
						:ficha="ficha"
						:entidad="entidad"
						:views="getViews.leftbody"
						:showtabs="getViews.leftbody.length >= 2"
						@saved="saved"
						@afterActions="afterActions"
						@setActionId="setActionId"
						@setCurrentAction="setCurrentAction"
						@reloadDataTable="reloadDataTable"
						@openWindow="val => $emit('openWindow',val)"/>

						<!-- [LEFT-FOOTER] -->
						<Zona
						ref="zona_left_footer"
						:class="[{'full-height': getViews.leftfooter.some(s => s.hook.zonafullheight)}]"
						v-if="getViews.leftfooter"
						:id="id"
						:ficha="ficha"
						:entidad="entidad"
						:views="getViews.leftfooter"
						@saved="saved"
						@afterActions="afterActions"
						@setActionId="setActionId"
						@setCurrentAction="setCurrentAction"
						@reloadDataTable="reloadDataTable"
						@openWindow="val => $emit('openWindow',val)"/>

					</div>
				</section>

				<!-- [CENTER] -->
				<section :class="['section-center', {'collapsed': !getFichaById(id) || !getFichaById(id).section.center.open}]">
					<div class="section-center-content">

						<!-- [CENTER-HEADER] -->
						<Zona
						ref="zona_center_header"
						:class="[{'full-height': getViews.centerheader.some(s => s.hook.zonafullheight)}]"
						v-if="getViews.centerheader"
						:id="id"
						:ficha="ficha"
						:entidad="entidad"
						:views="getViews.centerheader"
						@saved="saved"
						@afterActions="afterActions"
						@setActionId="setActionId"
						@setCurrentAction="setCurrentAction"
						@reloadDataTable="reloadDataTable"
						@openWindow="val => $emit('openWindow',val)"
						style="background-color: white"/>

						<!-- [CENTER-BODY] -->
						<Zona
						ref="zona_center_body"
						:class="[{'full-height': getViews.centerbody.some(s => s.hook.zonafullheight)}]"
						v-if="getViews.centerbody"
						:id="id"
						:ficha="ficha"
						:entidad="entidad"
						:views="getViews.centerbody"
						:showtabs="this.id == undefined ? getViews.centerbody.length >= 2 : true"
						@saved="saved"
						@afterActions="afterActions"
						@setActionId="setActionId"
						@setCurrentAction="setCurrentAction"
						@reloadDataTable="reloadDataTable"
						@openWindow="val => $emit('openWindow',val)"/>

						<!-- [CENTER-FOOTER] -->
						<Zona
						ref="zona_center_footer"
						:class="[{'full-height': getViews.centerfooter.some(s => s.hook.zonafullheight)}]"
						v-if="getViews.centerfooter"
						:id="id"
						:ficha="ficha"
						:entidad="entidad"
						:views="getViews.centerfooter"
						@saved="saved"
						@afterActions="afterActions"
						@setActionId="setActionId"
						@setCurrentAction="setCurrentAction"
						@reloadDataTable="reloadDataTable"
						@openWindow="val => $emit('openWindow',val)"/>
						
					</div>
				</section>

				<!-- [RIGHT] -->
				<section 
					:class="[
						'section-right', 
						{ 'collapsed': !getFichaById(id) || !getFichaById(id).section.right.open },
						{ 'drawer-style': this.id == undefined || !getFichaById(id).section.right.drawer ? false : true }
					]">

					<div class="section-right-content">

						<!-- Boton flotante cerrar cuando el estilo drawer esta activo -->
						<div class="drawer-style-button" @click="setFichaVisibleSection({id, section: 'right'})">
							<i class="el-icon-arrow-right"></i>
						</div>

						<!-- [RIGHT-HEADER] -->
						<Zona
						ref="zona_left_header"
						:class="[{'full-height': getViews.rightheader.some(s => s.hook.zonafullheight)}]"
						v-if="getViews.rightheader"
						:id="id"
						:ficha="ficha"
						:entidad="entidad"
						:views="getViews.rightheader"
						@saved="saved"
						@afterActions="afterActions"
						@setActionId="setActionId"
						@setCurrentAction="setCurrentAction"
						@reloadDataTable="reloadDataTable"
						@openWindow="val => $emit('openWindow',val)"/>

						<!-- [RIGHT-BODY] -->
						<Zona
						ref="zona_left_body"
						:class="[{'full-height': getViews.rightbody.some(s => s.hook.zonafullheight)}]"
						v-if="getViews.rightbody"
						:id="id"
						:ficha="ficha"
						:entidad="entidad"
						:views="getViews.rightbody"
						:showtabs="true"
						@saved="saved"
						@afterActions="afterActions"
						@setActionId="setActionId"
						@setCurrentAction="setCurrentAction"
						@reloadDataTable="reloadDataTable"
						@openWindow="val => $emit('openWindow',val)"/>

						<!-- [RIGHT-FOOTER] -->
						<Zona
						ref="zona_left_footer"
						:class="[{'full-height': getViews.rightfooter.some(s => s.hook.zonafullheight)}]"
						v-if="getViews.rightfooter"
						:id="id"
						:ficha="ficha"
						:entidad="entidad"
						:views="getViews.rightfooter"
						@saved="saved"
						@afterActions="afterActions"
						@setActionId="setActionId"
						@setCurrentAction="setCurrentAction"
						@reloadDataTable="reloadDataTable"
						@openWindow="val => $emit('openWindow',val)"/>

					</div>
				</Section>

				<!-- [MASTER-FOOTER] -->
				<section class="section-master section-master--footer">

					<!-- [MASTER-FOOTER-LEFT] -->
					<section class="section-left">
						<Zona
						ref="zona_master_footer_left"
						:class="[{'full-height': getViews.masterfooterleft.some(s => s.hook.zonafullheight)}]"
						v-if="getViews.masterfooterleft"
						:id="id"
						:ficha="ficha"
						:entidad="entidad"
						:views="getViews.masterfooterleft"
						@saved="saved"
						@afterActions="afterActions"
						@setActionId="setActionId"
						@setCurrentAction="setCurrentAction"
						@reloadDataTable="reloadDataTable"
						@openWindow="val => $emit('openWindow',val)"/>
					</section>

					<!-- [MASTER-FOOTER-RIGHT] -->
					<section class="section-right">
						<Zona
						ref="zona_master_footer_right"
						:class="[{'full-height': getViews.masterfooterright.some(s => s.hook.zonafullheight)}]"
						v-if="getViews.masterfooterright"
						:id="id"
						:ficha="ficha"
						:entidad="entidad"
						:views="getViews.masterfooterright"
						@saved="saved"
						@afterActions="afterActions"
						@setActionId="setActionId"
						@setCurrentAction="setCurrentAction"
						@reloadDataTable="reloadDataTable"
						@openWindow="val => $emit('openWindow',val)"/>
					</section>
				</section>

				<!-- [DRAWER-TOP] -->
				<el-drawer
					:visible.sync="hookDrawerTop"
					direction="ttb"
					:modal-append-to-body="false"
					:modal="false"
					:with-header="false">
					<div class="hookDrawer">
						<Zona
							ref="zona_drawer_top"
							:class="[{'full-height': getViews.drawertop.some(s => s.hook.zonafullheight)}]"
							v-if="getViews.drawertop"
							:id="id"
							:ficha="ficha"
							:entidad="entidad"

							:views="getViews.drawertop"
							@saved="saved"
							@afterActions="afterActions"
							@setActionId="setActionId"
							@setCurrentAction="setCurrentAction"
							@reloadDataTable="reloadDataTable"
							@openWindow="val => $emit('openWindow',val)"/>
					</div>
				</el-drawer>

				<!-- [DRAWER-BOTTOM] -->
				<el-drawer
					:visible.sync="hookDrawerBottom"
					direction="btt"
					:modal-append-to-body="false"
					:modal="false"
					:with-header="false">
					<div class="hookDrawer">
						<Zona
							ref="zona_drawer-bottom"
							:class="[{'full-height': getViews.drawerbottom.some(s => s.hook.zonafullheight)}]"
							v-if="getViews.drawerbottom"
							:id="id"
							:ficha="ficha"
							:entidad="entidad"

							:views="getViews.drawerbottom"
							@saved="saved"
							@afterActions="afterActions"
							@setActionId="setActionId"
							@setCurrentAction="setCurrentAction"
							@reloadDataTable="reloadDataTable"
							@openWindow="val => $emit('openWindow',val)"/>
					</div>
				</el-drawer>

				<!-- [DRAWER-LEFT] -->
				<el-drawer
					:visible.sync="hookDrawerLeft"
					direction="ltr"
					:modal-append-to-body="false"
					:modal="false"
					:size="'40%'"
					:with-header="false">

					<div class="hookDrawer">

						<!-- [DRAWER-LEFT-HEADER] -->
						<Zona
						ref="zona_drawer_left_header"
						:class="[{'full-height': getViews.drawerleftheader.some(s => s.hook.zonafullheight)}]"
						v-if="getViews.drawerleftheader"
						:id="id"
						:ficha="ficha"
						:entidad="entidad"
						:views="getViews.drawerleftheader"
						@saved="saved"
						@afterActions="afterActions"
						@setActionId="setActionId"
						@setCurrentAction="setCurrentAction"
						@reloadDataTable="reloadDataTable"
						@openWindow="val => $emit('openWindow',val)"/>

						<!-- [DRAWER-LEFT-BODY] -->
						<Zona
						ref="zona_drawer_left_body"
						:class="[{'full-height': getViews.drawerleftbody.some(s => s.hook.zonafullheight)}]"
						v-if="getViews.drawerleftbody"
						:id="id"
						:ficha="ficha"
						:entidad="entidad"
						:views="getViews.drawerleftbody"
						:showtabs="true"
						@saved="saved"
						@afterActions="afterActions"
						@setActionId="setActionId"
						@setCurrentAction="setCurrentAction"
						@reloadDataTable="reloadDataTable"
						@openWindow="val => $emit('openWindow',val)"/>

						<!-- [DRAWER-LEFT-FOOTER] -->
						<Zona
						ref="zona_drawer_left_body"
						:class="[{'full-height': getViews.drawerleftfooter.some(s => s.hook.zonafullheight)}]"
						v-if="getViews.drawerleftfooter"
						:id="id"
						:ficha="ficha"
						:entidad="entidad"
						:views="getViews.drawerleftfooter"
						@saved="saved"
						@afterActions="afterActions"
						@setActionId="setActionId"
						@setCurrentAction="setCurrentAction"
						@reloadDataTable="reloadDataTable"
						@openWindow="val => $emit('openWindow',val)"/>

					</div>
				</el-drawer>

				<!-- [DRAWER-RIGHT] -->
				<el-drawer
					:visible.sync="hookDrawerRight"
					direction="rtl"
					:modal-append-to-body="false"
					:modal="false"
					:size="'40%'"
					:with-header="false">

					<div class="hookDrawer">

						<!-- [DRAWER-RIGHT-HEADER] -->
						<Zona
						ref="zona_drawer_right_header"
						:class="[{'full-height': getViews.drawerrightheader.some(s => s.hook.zonafullheight)}]"
						v-if="getViews.drawerrightheader"
						:id="id"
						:ficha="ficha"
						:entidad="entidad"
						:views="getViews.drawerrightheader"
						@saved="saved"
						@afterActions="afterActions"
						@setActionId="setActionId"
						@setCurrentAction="setCurrentAction"
						@reloadDataTable="reloadDataTable"
						@dblClickSearch="val => $emit('dblClickSearch',val)"/>

						<!-- [DRAWER-RIGHT-BODY] -->
						<Zona
						ref="zona_drawer_right_body"
						:class="[{'full-height': getViews.drawerrightbody.some(s => s.hook.zonafullheight)}]"
						v-if="getViews.drawerrightbody"
						:id="id"
						:ficha="ficha"
						:entidad="entidad"
						:views="getViews.drawerrightbody"
						:showtabs="true"
						@saved="saved"
						@afterActions="afterActions"
						@setActionId="setActionId"
						@setCurrentAction="setCurrentAction"
						@reloadDataTable="reloadDataTable"
						@dblClickSearch="val => $emit('dblClickSearch',val)"/>

						<!-- [DRAWER-RIGHT-FOOTER] -->
						<Zona
						ref="zona_drawer_right_footer"
						:class="[{'full-height': getViews.drawerrightfooter.some(s => s.hook.zonafullheight)}]"
						v-if="getViews.drawerrightfooter"
						:id="id"
						:ficha="ficha"
						:entidad="entidad"
						:views="getViews.drawerrightfooter"
						@saved="saved"
						@afterActions="afterActions"
						@setActionId="setActionId"
						@setCurrentAction="setCurrentAction"
						@reloadDataTable="reloadDataTable"
						@dblClickSearch="val => $emit('dblClickSearch',val)"/>

					</div>
				</el-drawer>

				<!-- Alert -->
				<!--<Alert
				:currentAction="currentAction"
				@cancel="cancelAction"
				@next="nextAction"/>-->

				<!-- Modal con formulario -->
				<el-dialog
					v-if="modal && modal.attr"
					:modal-append-to-body="false"
					:modal="false"
					:lock-scroll="true"
					:title="modal.attr.title"
					:visible.sync="modal.visible"
					:close-on-click-modal="false"
					:close-on-press-escape="false"
					width="50%"
					class="modal-porlet"
					:show-close="false"
					:before-close="modalClose">
					
					<Porlet
						:inputList="modal.inputList"
						:modal="modal"
						:porlet="{
							tipo: 'porlet'
						}"
						:shadow="false"
						:focus="true"
						:autosave="false"
						:id="id"
						:ficha="ficha"
						:entidad="entidad"
						:objects="modal.objects"
						:showShadow="false"
						@afterActions="afterActions"
						@setActionId="setActionId"
						@closed="modalClose"
						@openWindow="val => $emit('openWindow',val)"
						@refsInputs="(val) => modal.inputList.push(...val)"/>

				</el-dialog>

				<!-- BUSCADOR -->
				<el-drawer
					title="Buscador"
					:visible.sync="drawerSearch"
					direction="ltr"
					:modal-append-to-body="false"
					:modal="false"
					:size="drawerSearchFullscreen ? '80%' : '20%' ">
						
						<Buscador
						:entidad="entidad"
						:drawerSearchFullscreen="drawerSearchFullscreen" 
						:drawerSearchFilter="drawerSearchFilter"
						@close="closedDrawerSearch"
						@dblclick="closedDrawerSearch"/>
			
				</el-drawer>

				<!-- SELECTOR -->
				<el-drawer
					:title="`${currentAction ? currentAction.input.title : ''}`"
					:modal-append-to-body="false"
					:modal="false"
					:size="'40%'"
					:visible.sync="drawer"
					:direction="direction"
					@closed="closedDrawer">

						<TableElement
						v-if="currentAction"
						@closeTableClick="closeTableClick"
						@saved="saved"
						@close="closeDrawerTableSelect"
						:currentAction="currentAction"
						:autoReload="true"
						:visibleSearch="false"
						:visibleSearchRow="false"
						:id="id"
						:entidad="entidad"
						:entidadRelacionada="currentAction.input.entidad"
						:fromModal="modal && modal.visible"/>

				</el-drawer>

				<!-- DRAWER IFRAME -->
				<el-drawer
					:title="showDrawerIframe.title"
					:modal-append-to-body="false"
					:modal="false"
					:size="'40%'"
					:visible.sync="showDrawerIframe.show"
					:direction="direction"
					@closed="closedDrawer">

						<iframe
						v-if="showDrawerIframe.show && showDrawerIframe.title && showDrawerIframe.url"
						:title="showDrawerIframe.title"
						width="100%"
						height="100%"
						frameborder="0"
						:src="showDrawerIframe.url">
					</iframe>

				</el-drawer>

			</template>

		</div>

		<div v-if="loadingAction || loading" class="loading-general">
			<div v-loading="true"></div>
		</div>

		<!-- EDITOR -->
		<EditorPanel v-if="config && config.editor" @setFichaFromEditor="setFichaFromEditor"/>
				
	</div>
</template>

<script>
    import Alert from '@/components/Alert.vue'
	import TableElement from '@/components/Porlet/PorletTableElement.vue'
	import Zona from '@/components/Zona.vue'
	import Buscador from '@/components/Porlet/PorletBuscador.vue'
	import EditorPanel from '@/components/Editor/EditorPanel.vue'

    import merge from 'deepmerge'

    import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

    import {
		getFichaEstructura,
		getFichaPersonalizacion,
		postAction,
		getInforme,
		getUrl,
		setDefaultsHeaders,
		fetchJSON
	} from '@/helpers/api'

	export default {
        name: 'FichaEstructura',
        components: {
			Alert,
			TableElement,
			Zona,
			Buscador,
			EditorPanel
		},
        props: {
            id: [String,Number],
            entidad: String,
			active: Boolean,
			asideDrawer: {
				type: Boolean,
				default: true
			},
			asideStatic: {
				type: Boolean,
				default: false
			},
			detailPage: {
				type: Boolean,
				default: false
			}
        },
        data () {
			return {

				// HOOKS DRAWER
				hookDrawerTop: false,
				hookDrawerBottom: false,
				hookDrawerLeft: false,
				hookDrawerRight: false,

				visibleHooks: ['Left','Center'],

				// CONTROL CARGA INICIAL
				loading: false,
				loadingAction: false,
				ready: false, // Carga completa

				// DATOS
				estructura: null,
				ficha: {},

				// ERRORES
				error: {
					estructura: false,
					personalizacion: false
				},

				// ACCCION ACTUAL
				currentAction: null,
				
				hookAcciones: {},
				hookAccionesLoading: true,

				// MOSTRAR ACCION EN MODAL
				modal: {
					visible: false,
					inputList: []
				},

				// DRAWER
				drawer: false,
				direction: 'rtl',
				   
				// DRAWER BUSCADOR
				drawerSearch: false,
				drawerSearchFullscreen: false,
				drawerSearchFilter: 'todos',

				// DRAWER IFRAME
				showDrawerIframe: {
					show: false,
					title: '',
					url: ''
				},

				// LISTA DE DATATABLES
				datatables: []
			}
		},
        computed: {
			...mapState({
				user: state => state.user.data,
				config: state => state.config.data,
				editor: state => state.config.editor,
				fichas: state => state.ficha.data
			}),
			...mapGetters([
				'getFichaById'
			]),
			getViews () {

				if (!this.ready) return

				return this.ficha.view ? Object.values(this.ficha.view).reduce((o, v) => {
					
					var _self = this
					function _assignEvents(elemento) {
						if(elemento.events && Object.keys(elemento.events).length) {
						
							Object.keys(elemento.events).forEach(key => {
								elemento.events[key] = _self[elemento.events[key]]
							})
						} else {
							elemento.events = {}
						}

						// Evento por defecto para acciones
						elemento.events.clickAction = _self['clickAction']

						// Añadir evento para fusionar view con la ficha
						elemento.events.updateFicha = _self['updateFicha']
					}

					v.cols.forEach(col => {
						Object.values(col.elementos).forEach(elemento => {

							_assignEvents(elemento)

							if (elemento.slots) {
								Object.values(elemento.slots).forEach(slot => {

									_assignEvents(slot)
								})
							}
						})
					})

					const key = (v.hook && v.hook.seccion && v.hook.zona) ? `${v.hook.seccion}${v.hook.zona}` : 'centerbody'

					if (!o[key]) o[key] = []

					o[key].push(v)

					return o

				}, {}) : []
			}
		},
        watch: {
			detailOpenTab (newVal) {
				//console.log('cambia detailOpenTab',newVal)
			},
			id() {
				this.setAxiosHeaders()
				this.getFichaPersonalizacion()
			},
			entidad() {
				this.setAxiosHeaders()
			},
			$mq() {
				
				this.controlRightMobile()
				
			},
			ficha() {

				if (!this.ficha.attr) return

				this.setFicha({
					id: this.id,
					entidad: this.entidad,
					title: this.ficha.attr.title
				})
			},
			active() {
				if (!this.active) return
				this.setAxiosHeaders()
			},
			fichas: {
				handler() {
					if(this.fichas.length <= 1) {
						this.setAxiosHeaders()
					}

					if(this.fichas.find(f => f.id == this.id && f.update)) {
						//console.log('actualizar ficha')
						this.refresh()
					}
				}, 
				deep: true
			}
		},
        mounted () {
			
			this.setAxiosHeaders()

			this.init()
			
			this.addFicha({
				id: this.id || null,
				entidad: this.entidad,
				title: '',
				update: false,
				section: {
					left: {
						open: this.id == undefined ? true : false // Menu izquierda activo solo en ficha base
					},
					center: {
						open: true
					},
					right: {
						open: this.asideStatic ? true : false,
						static: this.asideStatic,
						drawer: this.asideDrawer
					}
				}
			})

			this.controlRightMobile()
		},
        methods: {
			...mapMutations([
				'addFicha',
				'setFicha',
				'setFichaVisibleSection',
				'setSectionData',
				'setUpdateFichaFalse'
			]),

            // Inicializar ficha
			async init () {
				
				if (['SiDMS.drive'].includes(this.entidad)) {

					await this.getDMSEstructura()

				} else {

					await this.getFichaEstructura()
				}

				this.setUpdateFichaFalse(this.id)
			},
			refresh() {
				//console.log('refresh')
				this.estructura = null
				this.ficha = {}
				this.init()
			},
			async getDMSEstructura() {

				this.loading = true
				this.error.estructura = false
				
				try {
					
					let {data} = await (await fetch(`/estructura_${this.entidad}.json`, {
						method: 'GET'
					})).json()

					this.ficha = data

				} catch (e) {
					this.error.estructura = true
				}

				this.loading = false
				this.ready = true

			},
            async getFichaEstructura () {

				console.log('getFichaEstructura')
				
				this.loading = true
				this.error.estructura = false

				try {

					let resp = null

					/*f (this.entidad == 'documentos') {
						
						if (this.id) {
							resp = await (await fetch(`/jsonDocumentos/default_base_documento.json`, {
								method: 'GET'
							})).json()
						} else {
							resp = await (await fetch(`/jsonDocumentos/default_base.json`, {
								method: 'GET'
							})).json()
						}

					} else {*/

					resp = await getFichaEstructura(this.entidad, this.user)
					console.log('getFichaEstructura resp: ',resp)
					//}

					//console.log('getFichaEstructura: ', resp)

					if (resp && resp.status == 200 && resp.data) {

						this.ficha = resp.data
						this.estructura = resp.data.estructura || null

						if (this.id) {
							
							await this.getFichaPersonalizacion()
							this.ready = true
						}

						this.ready = true
						
					} else {
						this.error.estructura = true
						this.ready = true
					}

				} catch (e) {
					console.log(e)
					this.error.estructura = true
					this.ready = true
				}

				this.loading = false
			},
			async getFichaPersonalizacion() {

				this.loading = true
				this.error.personalizacion = false

				try {
					
					let resp = await getFichaPersonalizacion(this.id, this.entidad)

					if (resp.status == 202 && resp.data) {
						
						this.updateFicha(resp.data, resp.status)

						// Acciones
						this.afterActions(resp.data)
						
					} else {
						this.error.personalizacion = true
					}

				} catch (e) {
					console.log(e)
					this.error.personalizacion = true
				}

				this.loading = false
			},
			
			// Controlar aside derecho en movil
			controlRightMobile() {

				if (this.id == undefined || !this.asideStatic) return

				if (['xs','sm'].includes(this.$mq)) {

					this.setSectionData({
						id: this.id,
						section: 'right',
						data: {
							open: false,
							static: false,
							drawer: true
						}
					})

				} else {

					this.setSectionData({
						id: this.id,
						section: 'right',
						data: {
							open: true,
							static: true,
							drawer: false
						}
					})
				}
			},

            // Establecer cabeceras de axios
			setAxiosHeaders() {
				
				/*axios.defaults.headers.common['Entidad'] = this.entidad
			
				if (this.id && !isNaN(parseInt(this.id))) {
					axios.defaults.headers.common['Id'] = this.id
				}*/
				setDefaultsHeaders(this.entidad, this.id)
			},

            // Accion de input ID -> abrir selector
			setActionId(input) {
				this.currentAction = { input }
				this.drawer = true
			},

			closedDrawer() {
				this.currentAction = null
			},

			// Drawer
			closeTable() {
				this.drawer = false
				this.currentAction = null
			},
            // Tratar cualquier accion que venga del menu o de cualquier boton con acción
			async clickAction(action, tableconfig, confirm = true) {
				
				console.log('clickAction', action)

				this.setAxiosHeaders()
				
				this.loadingAction = true

				let reftable = (tableconfig && tableconfig.reftable && this.$referencias[tableconfig.reftable]) ? tableconfig.reftable : 'datatable_buscador'

				let selection = this.$referencias[reftable] ? this.$referencias[reftable].multipleSelection.map(m => m.id) : []

				if (action.openType) {

					if (action.openType == 'window') {
						this.$emit('openWindow', action)
					} else {
						this.showDrawerIframe.show = true
						this.showDrawerIframe.title = action.titulo
						this.showDrawerIframe.url = action.url
					}
					
				} else if (action.auto && action.url) {

					// Si tiene confirmacion abrir modal
					if (action.confirm && confirm) {
					
						this.$confirm(confirm.message || '¿Seguro que desea continuar?', confirm.title || 'Atención', {
							confirmButtonText: confirm.continueButton || 'Continuar',
							cancelButtonText: confirm.cancelButton || 'Cancelar',
							type: confirm.type || 'warning',
							center: confirm.center || false
						}).then(() => {
							
							this.clickAction(action, tableconfig, false)

						}).catch(() => {
							this.loadingAction = false
						})

						return
					}

                    try {

						let data = {}

						// Añadir seleccion de filas
						if (selection && selection.length) data.selection = selection

						// Añadir campos de ficha
						if (action.addFields && action.addFields.length) {

							action.addFields.forEach(field => {
								data[field] = this.ficha.data[field].value
							})
						}
						
						// Comprobar si la url es un JSON
						let resp = null
						if (action.url.includes('.json')) {
							resp = await fetchJSON(action.url) // Utilizado en documentos
						} else {
							resp = await postAction(action.url, action.metodo.toLowerCase() || 'post', data) // Metodo: GET/POST/PUT/PATH/DELETE, default: post
						}
						

						// Acciones
						this.afterActions(resp.data, action)

						// Limpiar selector multiple de tablas
						if (selection && selection.length) {
							if (tableconfig) {

								let {reftable} = tableconfig

								if(this.$referencias && this.$referencias[reftable]) {

									this.$referencias[reftable].$refs.table.clearSelection()
								}

							} else if (this.$referencias && this.$referencias.datatable_buscador) {

								this.$referencias.datatable_buscador.$refs.table.clearSelection()
							}
						}

						// Actualizar ficha
						this.updateFicha(resp.data, resp.status)

                    } catch (err) {
						console.log(err)
                        this.$notify.error({
                            title: 'Error',
                            message: 'Ha ocurrido un error'
                        });
						
                    }

				} else if (action.function) {

					this[action.function]()

				} else if (action.informe) {

					try {
					
						let resp = await getInforme(
							action.informe, 
							action.tipo, 
							{
								entidad: this.entidad,
								id: this.id
							}
						)

						// Acciones
						this.afterActions(resp.data, action)

						// Actualizar ficha
						this.updateFicha(resp.data, resp.status)

					} catch (err) {
						console.log(err)
						this.$notify.error({
							title: 'Error',
							message: 'Ha ocurrido un error'
						});
					}
				}
				
				this.loadingAction = false
			},

			// Cerrar tabla select del drawer
			closeDrawerTableSelect(value) {
				console.log('closeDrawerTableSelect ',value)

				if (this.currentAction && this.currentAction.input) {

					let object = this.modal.objects.find(f => f.key === this.currentAction.input.key)
					object.value = value.id

					// Obtener campos relacionados a traves de la propiedad "auto"
					let object_auto = this.modal.objects.find(f => f.auto && f.auto.includes(`${object.entidad}->`))
					if (object_auto) {
						object_auto.value = value[object_auto.auto.split('->')[1]]
					}

					this.drawer = false
					this.currentAction = null
				}
			},

			// Cerrar tabla con un click
			closeTableClick({data,status}) {
				if(status) {
					this.ficha.data = merge(this.ficha.data, data)
				}
				this.closeTable()
			},

			// Cerrar modal
			modalClose() {
				this.modal = { visible: false }
			},

			// Alternar secciones hooks visibles
 			setCollapseHooks(data) {
				this.visibleHooks = data
			},
            nextAction() {
				this.drawer = true
			},
			cancelAction() {
				this.drawer = false
				this.currentAction = null
			},

			// Establecer una accion a mostrar
			async setCurrentAction ({action,input}) {

				//this.drawer = true
				this.currentAction = {action,input}
				this.nextAction() // TEMPORAL
			},

			// Abrir buscador
			openSearch() {
				this.drawerSearch = true
			},

			// Drawer Search
			closedDrawerSearch({value,dblclick}) {
				//console.log('closedDrawerSearch: ',value)
				if (value == null) return
				if (dblclick) this.drawerSearch = false
			},

			// Guardado de input
			saved(val) {

				//console.log('saved: ',val)

				// Recargar ficha
				if (val.recargarFicha) {

					this.refresh()

				} else if (val.data) {

					// Fusionar data
					this.$set(this.ficha,'data',merge(this.ficha.data, val.data))
				}

				// Acciones
				this.afterActions(val)

			},
			
			// Acciones comunes que se realizan despues de una peticion
			afterActions (data, action) {

				//console.log('afterActions', data)

				// Actualizar componente
				if (data.recargarComponentes && data.recargarComponentes.length) {
					data.recargarComponentes.forEach(comp => {
						this.$referencias[comp].refresh()
					})
				}

				// Actualizar getData del componente
				if (data.recargarComponentesData && data.recargarComponentesData.length) {
					data.recargarComponentesData.forEach(comp => {
						this.$referencias[comp].refreshData()
					})
				}

				// Redirect
				if(data.redirect) {
					this.$emit('openWindow', {
						entidad: data.redirect.split('/')[0],
						id: data.redirect.split('/')[1]
					})
				}

				// Recargar ficha
				if (data.recargarFicha) {
					this.refresh()
				}

				// Descarga de fichero
				if (data && data.link) {

					if (typeof data.link == 'object') {

						data.link.forEach(link => {

							this.openwindow(`${getUrl().backendDownload}${link}`)
						})
						
					} else {

						this.openwindow(`${getUrl().backendDownload}${data.link}`)
					}

				}

				// Abrir modal
				if(data.modal) {

					let objects = []

					if (data.modal.data && Object.keys(data.modal.data).length) {
						
						objects = Object.keys(data.modal.data).map(key => {
							const el = data.modal.data[key]
							el.key = key
							return (typeof el == 'object') ? el : ''
						}, this)
						.filter(el => el !== '')
						.sort((a,b) => a.order - b.order)
					}

					this.modal = {
						...data.modal,
						visible: true, 
						action,
						objects,
						inputList: []
					}
				}
				
				// Abrir nueva pestaña de navegador
				if(data.windowopen) {
					this.openwindow(data.windowopen,'_blank')
				}

				// Abrir en iframe de ventana
				if(data.openWindowIframe) {
					this.$emit('openWindow', {
						titulo: data.openWindowIframe.titulo,
						url: data.openWindowIframe.url,
						openType: 'iframe'
					})
				}

				// Mostrar mensajes
				this.mostrarMensajes(data.mensajes)
			},
			mostrarMensajes(mensajes) {

				if (!mensajes) return

				// Alert
				let hasAlerts = mensajes.filter(f => f['message-type'] === 'Alert')
				if (hasAlerts && hasAlerts.length) {
					this.$alert(hasAlerts.map(m => `<p>${m.message}</p>`).join(''), hasAlerts[0].title, {
						confirmButtonText: 'Aceptar',
						dangerouslyUseHTMLString: true
					})
				}

				// Notificciones
				mensajes.filter(f => f['message-type'] !== 'Alert').forEach(mensaje => {
					setTimeout(() => {
						this.$notify({
							title: mensaje.title,
							message: mensaje.message,
							type: mensaje.type,
							position: mensaje.position
						});
					}, 5)
				})
			},

			// Merge ficha con nuevos valores
			updateFicha(data, status = 200) {

				console.log('updateFicha before', this.ficha)
				console.log('updateFicha after', data)

				let ficha = ''

				switch(status) {
					case 200:
						ficha = merge(this.ficha, data)
						break;
					
					case 201:
						ficha = data
						break;

					case 202:
						const overwriteMerge = (destinationArray, sourceArray, options) => sourceArray
						ficha = merge(this.estructura, data, { arrayMerge: overwriteMerge })
						break;
					
					case 203:
						ficha = merge(this.estructura, data)
						break;
				}

				this.ficha = ficha
			},

            // Recargar una tabla en concreto
			reloadDataTable(table) {
				//console.log('ficha - reload datatable: ', table)
			},

			// Abrir Hook DrawerRight
			openHookDrawerRight() {
				this.hookDrawerRight = true
			},

			// Editor
			setFichaFromEditor(data) {
				this.ficha = JSON.parse(JSON.stringify(data))
			}
        }
	}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';
.content-ficha {
	display: flex;
    flex-flow: row;
    flex-grow: 1;
	height: 100%;

	&.window-active .page-element{
		height: calc(100% - 30px);
	}

	.page-element {
		display: flex;
		height: 100%;
		flex-grow: 1;
		overflow: auto;

		&.with-header {
			height: calc(100vh - 60px);
			padding-top: 60px;
			section.section-master.section-master--header {
				display: flex;
			}
		}
		&.with-footer {
			height: calc(100vh - 60px);
			padding-bottom: 60px;
			section.section-master.section-master--footer {
				display: flex;
			}
		}
		&.with-header-footer {
			height: calc(100vh - 120px);
			padding-top: 60px;
			padding-bottom: 60px;
			section.section-master {
				&.section-master--header,
				&.section-master--footer {
					display: flex;
				}
			}
		}
		&.detail-page {
			&.device-mobile {
				.section-center {
					min-width: auto!important;
				}
			}
			.section-center {
				width: 900px!important;
				max-width: 900px!important;
				min-width: 900px;
				@media (min-width: 1900px) {
					width: 1200px!important;
					max-width: 1200px!important;
				}
			}
		}

		// Maquetacion drawer
		.el-drawer__wrapper {
			position: absolute;

			.el-drawer__container.el-drawer__open {
				background-color: #00000066;
			}
		}
		.v-modal {
			position: absolute;
		}

		// Maquetacion dialog
		.el-dialog__wrapper {
			position: absolute;
			background-color: #00000066;
		}

		// Zonas
		.zona {
			&.full-height {
				height: 100%;
				overflow: hidden;
				> div {
					height: 100%;
					.el-row {
						height: 100%;
						.el-col {
							height: 100%;
							> div {
								height: 100%;
							}
						}
					}
				}
				.el-tabs {
					padding: 0px;
					.el-tabs__header {
						box-shadow: unset!important;
						padding: 0px;
						.el-tabs__nav-wrap::after {
							background-color: #E4E7ED;
						}
					}
					.el-tabs__content {
						padding: 0px;
					}
				}
			}
		}

		// MASTER HEADER/FOOTER
		section.section-master {
			background-color: white;
			width: 100%;
			position: absolute;
			height: 60px;
			z-index: 9;
			&.section-master--header {
				display: none;
				top: 0;
			}
			&.section-master--footer {
				display: none;
				bottom: 0;
			}
			.section-left {
				display: flex;
				flex-grow: 1;
				height: 100%;
				overflow: hidden;
			}
			.section-right {
				display: flex;
				flex-grow: 1;
				justify-content: flex-end;
				height: 100%;
				overflow: hidden;
			}
		}

		.collapse {
			width: 20px;
			background-color:#4a596a29;
			display: block;
			color: #4a596a;
			font-size: 13px;
			display: flex;
			justify-content: center;
			padding-top: 5px;
			cursor: pointer;
			z-index: 9;
		}

		// LEFT SECTION
		.section-left {
			width: 200px;
			height: 100%;
			display: flex;
			flex-shrink: 0;
			background-color: white;
			border-right: 1px solid rgba(0,0,0,.1);
			overflow: auto;
			overflow-x: hidden;
			
			.drawer-style-button {
				display: none;
			}

			&.collapsed {
				width: auto;
				border: 0px;
				.section-left-content {
					display: none;
				}
				.collapse {
					background-color:#4a596a;
					color:white;
				}
				&.drawer-style {
					box-shadow: none;
				}
			}

			&.drawer-style {
				position: absolute;
				z-index: 99;
				box-shadow: 0 8px 10px -5px rgba(0,0,0,.2), 0 16px 24px 2px rgba(0,0,0,.14), 0 6px 30px 5px rgba(0,0,0,.12);

				.drawer-style-button {
					display: flex;
					justify-content: flex-end;
					padding: 5px;
					font-size: 1.3rem;
					cursor: pointer;
				}
			}

			.section-left-content {
				width: 100%;
				a {
					text-decoration: none;
					color: inherit;
				}
				.el-menu {
					background-color: transparent;
					border: 0px;
					li.el-menu-item {
						color: #4a596a;
						i {
							color: #4a596a;
						}
					}
					.el-menu-item:focus, .el-menu-item:hover {
						outline: 0;
						background-color: #ffffff;
					}
				}
			}
		}

		// CENTER SECTION
		.section-center {
			//width: 1140px;
			height: 100%;
			
			overflow: auto;
			//padding: 20px;
			flex-grow: 0;
			flex-shrink: 0;

			display: flex;
			flex-flow: row;
			flex-grow: 1;
			flex-shrink: 1;

			overflow-x: hidden;
			background-color: $--color-background;
			
			&.collapsed {
					width: auto;
					.section-center-content {
						display: none;
					}
					.collapse {
						background-color:#4a596a;
						color:white;
					}
				}
			.section-center-content {
				display: flex;
				flex-direction: column;
				width: 100%;
				
			}
		}

		// RIGHT SECTION
		.section-right {
			display: flex;
			flex-grow: 1;
			border-left: 1px solid #e5e5e5;
			min-width: 400px;

			.drawer-style-button {
				display: none;
			}

			&.collapsed {
				display: none;
				.collapse {
					background-color:#4a596a;
					color:white;
				}
			}

			&.drawer-style {
				position: absolute;
				top: 0;
				right: 0;
				bottom: 0;
				width: 90%;
				z-index: 99;
				box-shadow: 0 8px 10px -5px rgba(0,0,0,.2), 0 16px 24px 2px rgba(0,0,0,.14), 0 6px 30px 5px rgba(0,0,0,.12);
				min-width: auto!important;
				@media(min-width: 768px) {
					width: 50%;
				}
				.drawer-style-button {
					display: flex;
					align-items: center;
					font-size: 12px;
					cursor: pointer;
					width: 25px;
					position: absolute;
					z-index: 99;
					background-color: white;
					border-radius: 50%;
					height: 25px;
					justify-content: center;
					box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.2), 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12);
					left: -16px;
					top: 50px;
				}
			}

			.section-right-content {
				width: 100%;
				padding: 0px;
				background-color: white;
				border-radius: 5px;
				overflow: auto;
				border-radius: 0px;

				

				.zona {
					height: 100%;
					display: flow-root;
					.tablon {
						height: 100%;
						.el-row {
							height: 100%;
							.el-col {
								height: 100%;
								.porlet-content {
									height: 100%;
								}
							}
						}
					}
				}
				/*.el-tabs.el-tabs--top {
					height: 100%;
					overflow: hidden;
					.el-tabs__content {
						overflow: hidden;
						position: relative;
						height: calc(100% - 40px);
						.el-tab-pane {
							height: 100%;
						}
					}
				}*/
			}
		}

		section.el-drawer__body {
			max-height: 100%;
		}

		// LOADING
		.loading-general {
			position: absolute!important;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			width: 100%;
			height: 100%;
			z-index: 999;
			> div {
				top: 0;
				left: 0;
				bottom: 0;
				right: 0;
				width: 100%;
				height: 100%;
			}
			.el-loading-mask {
				background-color: rgba(255, 255, 255, 0.33);
			}
		}
		.el-loading-mask {
			z-index: 99!important;
		}

		// DRAWER
		.el-drawer__header {
			margin-bottom: 20px;
		}

		// MODAL PORLET
		.modal-porlet {

			.el-dialog {
				border-radius: 6px;

				.el-dialog__header {
					padding: 15px 20px 15px;
					box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15), 0 0 1px rgba(0, 0, 0, 0.08);
					z-index: 99;
					position: absolute;
					left: 0;
					right: 0;
					background-color: white;
					border-radius: 6px 6px 0px 0px;
				}

				.el-dialog__body {
					border-radius: 6px;
					padding: 75px 20px 1px 20px;
					background-color: #fafafa;
					.porlet-content.porlet-light {
						background-color: transparent;
						.formulario {
							background-color: transparent;
							.form-group {
								background-color: white;
							}
							&.formulario-bg-white {
								background-color: white;
								border: 1px solid #e9e9eb;
								border-radius: 4px!important;
								overflow: hidden;
							}
						}
					}
					footer {
						margin-top: 15px;
					}
				}
			}
		}

		.card {
			background-color: white;
			border-radius: 5px;
			box-shadow: 0 8px 16px 0 rgba(40,40,90,.09), 0 3px 6px 0 rgba(0,0,0,.065);
		}

		.hookDrawer {
			height: 100%;
			overflow: hidden;
		}
	}
}
</style>